// extracted by mini-css-extract-plugin
module.exports = {"card":"UnClaimedBusinessCard_card__2dr0A","description":"UnClaimedBusinessCard_description__3vNZ0","btn":"UnClaimedBusinessCard_btn__3teVu"};